// Comes from shadcn/ui expansions : https://shadcnui-expansions.typeart.cc/docs/spinner

import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";
import { Loader2 } from "lucide-react";
import React from "react";

const spinnerVariants = cva("flex-col items-center justify-center", {
    variants: {
        show: {
            true: "flex",
            false: "hidden",
        },
    },
    defaultVariants: {
        show: true,
    },
});

const loaderVariants = cva("animate-spin text-primary text-primary-dark", {
    variants: {
        size: {
            small: "size-6",
            medium: "size-8",
            large: "size-12",
        },
    },
    defaultVariants: {
        size: "medium",
    },
});

export interface SpinnerContentProps
    extends
        VariantProps<typeof spinnerVariants>,
        VariantProps<typeof loaderVariants> {
    className?: string;
    children?: React.ReactNode;
}

const Spinner = ({ size, show, children, className }: SpinnerContentProps) => (
    <span className={spinnerVariants({ show })}>
        <Loader2 className={cn(loaderVariants({ size }), className)} />
        {children}
    </span>
);

export default Spinner;
